import Table from '@/components/Table/Table.jsx'
import TableChooseComponent from '../_COMPONENT/TableChooseComponent.jsx'
import {useTableColumnBdName, useTableColumnBdNo} from '../BD/useTableColumnBd.jsx'
import StoryType from '../BDSUMMARY/StoryType.jsx'

const TableChooseBdsummary = (props) => {
    const columns = [
        useTableColumnBdName(),
        useTableColumnBdNo(),

        {
            title: '用户场景类型',
            dataIndex: 'storyType',
            component: <Table.ViewDict dict={Object.fromEntries(StoryType)} />,
        },

        {
            title: '用户场景标题',
            dataIndex: 'algTitle',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseComponent
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseBdsummary
